import SEO from "../components/SEO";
import { SectionLabel } from "../components/Reveal";
import { legalPages } from "../data/legal";
import { useContent } from "../data/siteContent";

const DEFAULTS = {
  email: "info.allcov@gmail.com",
  phone: "+91-70650-28801",
  address: "Ground Floor, D-9, Vyapar Marg, Sector 3, Noida, Uttar Pradesh 201301",
};

export default function LegalPage({ slug }) {
  const page = legalPages[slug];
  const { contact } = useContent();

  const localize = (text) =>
    text
      .replaceAll(DEFAULTS.email, contact.email || DEFAULTS.email)
      .replaceAll(DEFAULTS.phone, contact.phone_display || DEFAULTS.phone)
      .replaceAll(DEFAULTS.address, contact.address || DEFAULTS.address);

  return (
    <div data-testid={`legal-${slug}`}>
      <SEO title={page.seoTitle} description={`${page.title} — ALLCOV LLP`} path={`/${slug}`} />
      <section className="border-b border-line">
        <div className="mx-auto max-w-3xl px-6 pb-14 pt-36 lg:pt-44">
          <SectionLabel>Legal</SectionLabel>
          <h1 className="font-batangas text-4xl tracking-tight md:text-5xl" data-testid="legal-title">{page.title}</h1>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-faint" data-testid="legal-updated">
            Last updated: {page.updated}
          </p>
        </div>
      </section>
      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-3xl space-y-10 px-6">
          {page.sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-batangas text-xl tracking-tight text-txt md:text-2xl">{s.h}</h2>
              {s.paras && s.paras.map((p, i) => (
                <p key={i} className="mt-4 text-sm leading-relaxed text-mut md:text-base">{localize(p)}</p>
              ))}
              {s.bullets && (
                <ul className="mt-4 space-y-3">
                  {s.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm leading-relaxed text-mut md:text-base">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-myrtle" aria-hidden="true" />
                      {localize(b)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
